import {memo, useMemo, lazy, Suspense} from 'react'
import {useSelector} from "react-redux";
import Plain from "../shared/loaders/Plain";
import isEqual from "fast-deep-equal/react";

const layouts = {
  single: lazy(() => import('../layout/SingleElementLayout')),
  simple: lazy(() => import('../layout/SimpleLayout'))
}

const Layout = props => {

  const {layoutType} = useSelector((state) => state.auth)

  const AppLayout = useMemo(() => {
    return layouts[layoutType]
  }, [layoutType])

  return (
    <Suspense fallback={<Plain/>}>
      <AppLayout {...props}/>
    </Suspense>
  )
}

export default memo(Layout, isEqual)